package net.maraclinic.app.theme

object Fonts {
    val Inter = "Inter"
    val DancingScript = "Dancing Script"
}